// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoBox_wrapper__4vfbn","container":"VideoBox_container__udKQU"};